import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from './useCurrentUser';
import type { User } from './api';

type GateState =
  | { ready: false; user: null }
  | { ready: true; user: User };

export function useRequireSuperAdmin(): GateState {
  const { status, user } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'signed-out') {
      navigate('/login', { replace: true });
      return;
    }
    if (status === 'signed-in' && user && !user.is_super_admin) {
      // Silent redirect — don't tell non-admins the admin section exists.
      navigate('/dashboard', { replace: true });
    }
  }, [status, user, navigate]);

  if (status === 'signed-in' && user?.is_super_admin) {
    return { ready: true, user };
  }
  return { ready: false, user: null };
}
